export default __webpack_public_path__ + "static/media/3.6b47358c.PNG";